/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Save_Project_TitleInputs */

const en_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Project`)
};

const fr_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le projet`)
};

const de_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt speichern`)
};

const it_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva progetto`)
};

const ru_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить проект`)
};

const es_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto`)
};

const zh_cn2_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目`)
};

const ja_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを保存`)
};

const hi_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट बचाओ`)
};

const pt_pt2_explorer_display_save_project_title = /** @type {(inputs: Explorer_Display_Save_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar projeto`)
};

/**
* | output |
* | --- |
* | "Save Project" |
*
* @param {Explorer_Display_Save_Project_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_project_title = /** @type {((inputs?: Explorer_Display_Save_Project_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_Project_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_save_project_title(inputs)
	if (locale === "de") return de_explorer_display_save_project_title(inputs)
	if (locale === "it") return it_explorer_display_save_project_title(inputs)
	if (locale === "ru") return ru_explorer_display_save_project_title(inputs)
	if (locale === "es") return es_explorer_display_save_project_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_save_project_title(inputs)
	if (locale === "ja") return ja_explorer_display_save_project_title(inputs)
	if (locale === "hi") return hi_explorer_display_save_project_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_save_project_title(inputs)
	return en_explorer_display_save_project_title(inputs)
});